import { BottomSheetChangeBreakpoint } from '../components/Modal/Modal';
import { ThemeProp } from './Themes';

/**
 * @returns the breakpoint at which the bottom sheet should change to a modal
 */
export const determineBreakpoint = (
  props: ThemeProp & { $bottomSheetChangeBreakpoint?: BottomSheetChangeBreakpoint },
) => {
  return props.$bottomSheetChangeBreakpoint === BottomSheetChangeBreakpoint.Tablet
    ? props.theme.breakpoints.tablet
    : props.theme.breakpoints.mobile;
};
